import {
	Grid,
	pageNavigationPlugin,
	PageNavigationPlugin,
} from "@valenzinsights/core-component";

import React from "react";

import { Splitter, SplitterPanel } from "primereact/splitter";

import { LibraryDocumentViewer } from "./LibraryDocumentViewer";
import { LibraryWebChat } from "./WebChatComponent/LibraryWebChat";

export const DocumentWebchat: React.FC<{}> = () => {
	const jumpToPagePluginInstance: PageNavigationPlugin = pageNavigationPlugin();

	const { jumpToPage } = jumpToPagePluginInstance;

	return (
		<>
			<style>
				{`
                    .custom-splitter .p-splitter-gutter {
                        background-color: #ccc; /* Change this to the color you prefer */
                        border: 1px solid #999; /* Change this to the color you prefer */
                        cursor: col-resize;
                    }
					button {
                        cursor: pointer;
                        width: fit-content;
                        height: 31.33px;
                        border-color: darkgrey;
                        border-radius: 5px;
                        font-size: smaller;
                    }

                    img {
                        cursor: pointer;
                    }
                `}
			</style>
			<Splitter style={{ height: "100vh" }} className="custom-splitter">
				<SplitterPanel size={65}>
					<Grid container style={{ height: "100%", margin: 0 }} direction="row">
						<Grid item lg={12} style={{ height: "100%" }}>
							<LibraryDocumentViewer
								jumpToPagePluginInstance={jumpToPagePluginInstance}
							/>
						</Grid>
					</Grid>
				</SplitterPanel>
				<SplitterPanel size={35}>
					<Grid container style={{ height: "100%", margin: 0 }} direction="row">
						<Grid item lg={12} style={{ height: "100%" }}>
							<LibraryWebChat jumpToPage={jumpToPage} />
						</Grid>
					</Grid>
				</SplitterPanel>
			</Splitter>
		</>
	);
};
